module.exports = __webpack_public_path__ + "static/media/icon_hqt.1d6b8024.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon_hqt.png
// module id = 386
// module chunks = 0 1